export default __webpack_public_path__ + "static/media/activeSimpleServo.dfbd2ba6.svg";